import { useQuery } from '@apollo/client';

import {
  AvailabilityState,
  GetOutOfStockAlternativesQuery,
  GetOutOfStockAlternativesQueryVariables,
} from '@notino/shared/definitions/types';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useProductDetailContext } from '../ProductDetailContext';

import productAlternativesQuery from './queries/productAlternatives.graphql';

export const useFetchProductAlternatives = () => {
  const { experiment_pd_outofstock_product_alternatives } = useFeatureFlags();
  const { product } = useProductDetailContext();
  const catTypes = product.categorization.types;

  const everyProductUnavailable = product.variants.every(
    (v) => v.availability.state !== AvailabilityState.CanBeBought
  );

  return useQuery<
    GetOutOfStockAlternativesQuery,
    GetOutOfStockAlternativesQueryVariables
  >(productAlternativesQuery, {
    variables: {
      productCode: product.masterProductCode,
      brandId: product.brand?.id ? Number(product.brand.id) : null,
      navigationValues: [
        catTypes.find((t) => t.primary)?.id ?? catTypes[0]?.id,
      ],
    },
    skip:
      !everyProductUnavailable ||
      !experiment_pd_outofstock_product_alternatives,
    ssr: false,
  });
};
